import styled from 'styled-components'
import { DividerProps } from './Divider.types'
import { dividerVariant, dividerAlign } from './variant'
import Flex from '../Flex'

export const StyledDivider = styled(Flex)<DividerProps>`
  ${dividerVariant};
  ${dividerAlign};
  ::after {
    content: '';
  }
  ::before {
    content: '';
  }
`
